module.exports = __webpack_public_path__ + "img/title-heros.60d63587.png";